import firebase from 'firebase/compat/app';

export class MembershipCode {
  id: string;
  uid: string;
  created: firebase.firestore.Timestamp;
  modified: firebase.firestore.Timestamp;
  membershipId: string;
}
